import { create } from 'zustand'
import { Project, PixelData, BoardSize, ColorMapping, PixelShape } from '@pindd/types'

interface ProjectState {
  project: Project | null
  setProject: (project: Project) => void
  updatePixelatedData: (data: PixelData) => void
  updateBoardSize: (size: BoardSize) => void
  updateColorMapping: (mapping: ColorMapping[]) => void
  updatePixelShape: (shape: PixelShape) => void
}

export const useProjectStore = create<ProjectState>((set) => ({
  project: null,
  setProject: (project) => set({ project }),
  updatePixelatedData: (data) =>
    set((state) => ({
      project: state.project ? { ...state.project, pixelatedData: data } : null
    })),
  updateBoardSize: (size) =>
    set((state) => ({
      project: state.project ? { ...state.project, boardSize: size } : null
    })),
  updateColorMapping: (mapping) =>
    set((state) => ({
      project: state.project ? { ...state.project, colorMapping: mapping } : null
    })),
  updatePixelShape: (shape) =>
    set((state) => ({
      project: state.project ? { ...state.project, pixelShape: shape } : null
    }))
}))
